import { ArrowRight } from "lucide-react";

// Golden scales of justice
const ABOUT_IMAGE = "https://images.pexels.com/photos/6077797/pexels-photo-6077797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260";

export const AboutPreview = () => {
  return (
    <section 
      id="about" 
      className="py-16 md:py-24 lg:py-32 bg-[#FAFAF9] relative"
      data-testid="about-preview"
    >
      {/* Decorative line - hidden on mobile */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-12 md:h-20 bg-gradient-to-b from-[#D4AF37]/50 to-transparent hidden md:block" />
      
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              {/* Gold frame - simplified on mobile */}
              <div className="absolute -inset-3 md:-inset-4 border border-[#D4AF37]/20 hidden md:block" />
              
              <img
                src={ABOUT_IMAGE}
                alt="Scales of Justice"
                className="w-full h-[300px] md:h-[450px] lg:h-[550px] object-cover grayscale hover:grayscale-0 transition-all duration-700"
                data-testid="about-image"
              />
              
              {/* Overlay badge */}
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-[#D4AF37] text-[#0A0A0B] p-4 md:p-6">
                <p className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold">15+</p>
                <p className="text-[10px] md:text-xs tracking-wider uppercase">Years Excellence</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
              About The Firm
            </span>
            
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-[#1A1A1A] mt-4 md:mt-6 mb-6 md:mb-8 leading-tight">
              Where Legal Precision
              <span className="block text-[#C5A028] italic">Meets Investment Strategy</span>
            </h2>
            
            <div className="w-16 md:w-20 h-px bg-[#D4AF37] mb-6 md:mb-8" />
            
            <div className="space-y-5 md:space-y-6 text-[#1A1A1A]/60 text-sm md:text-base leading-[1.8] md:leading-[1.9]">
              <p>
                4 ACES Attorneys is a specialised property and real estate law practice serving 
                discerning investors, developers, and diaspora Nigerians seeking secure property 
                transactions in Nigeria.
              </p>
              <p>
                Led by <strong className="text-[#1A1A1A]">Precious Ohiri-Leghemo</strong>, 
                Founder and Principal Counsel, the firm combines deep legal expertise with 
                strategic advisory to protect clients' investments and ensure clear, enforceable 
                property ownership.
              </p>
              <p>
                Our work focuses on property due diligence, title verification, acquisition advisory, 
                and transaction structuring — helping clients navigate Nigeria's property market with 
                clarity, security, and confidence.
              </p>
            </div>

            {/* Stats row */}
            <div className="flex gap-6 md:gap-10 lg:gap-12 mt-8 md:mt-10 pt-8 md:pt-10 border-t border-[#E5E5E5]">
              <div>
                <p className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl text-[#D4AF37] font-bold">100+</p>
                <p className="text-[10px] md:text-xs text-[#1A1A1A]/50 mt-1 leading-tight">Transactions<br/>Advised</p>
              </div>
              <div>
                <p className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl text-[#D4AF37] font-bold">50+</p>
                <p className="text-[10px] md:text-xs text-[#1A1A1A]/50 mt-1 leading-tight">Diaspora Clients<br/>Served</p>
              </div>
              <div>
                <p className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl text-[#D4AF37] font-bold">₦5B+</p>
                <p className="text-[10px] md:text-xs text-[#1A1A1A]/50 mt-1 leading-tight">Property Value<br/>Protected</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
